export var getAlwaysOnText = function getAlwaysOnText() {
  return 'Always on';
};